import React from 'react';
import PropTypes from 'prop-types';

var styles$1 = {"cell":"-yfd8","header":"nbKRB","selected":"ebVQe","editing":"m7Ep4","singleSelection":"FJhh3","hideLastBlock":"JQaEp","editorWrapper":"Ci50y","viewerWrapper":"bLarR","hideFirstBlock":"K63we","editor":"fMrCg","edit":"h-abp","view":"p9bIe","editingToolbarWrapper":"yBx3v","selectAll":"CUUyu","disableSelection":"Xg7Y3"};

var styles = {"borderT":"LSly5","borderB":"Lkg--","borderL":"drvuN","borderR":"e-9Xc"};

var CellBorders = function CellBorders(_ref) {
  var borders = _ref.borders;
  return [(borders == null ? void 0 : borders.top) && /* @__PURE__ */React.createElement("div", {
    key: "top",
    style: {
      background: borders.top
    },
    className: styles.borderT
  }), (borders == null ? void 0 : borders.bottom) && /* @__PURE__ */React.createElement("div", {
    key: "bottom",
    style: {
      background: borders.bottom
    },
    className: styles.borderB
  }), (borders == null ? void 0 : borders.right) && /* @__PURE__ */React.createElement("div", {
    key: "right",
    style: {
      background: borders.right
    },
    className: styles.borderR
  }), (borders == null ? void 0 : borders.left) && /* @__PURE__ */React.createElement("div", {
    key: "left",
    style: {
      background: borders.left
    },
    className: styles.borderL
  })];
};
CellBorders.propTypes = {
  borders: PropTypes.object
};

export { CellBorders as C, styles$1 as s };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'